// Section: Hero Component
import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section id="hero" className="hero-section">
      {/* Background with animated particles */}
      <div className="hero-background">
        {/* Animated background particles */}
        <div className="particles-container">
          {[...Array(50)].map((_, i) => (
            <motion.div
              key={i}
              className="particle"
              animate={{
                x: [0, Math.random() * 100 - 50],
                y: [0, Math.random() * 100 - 50],
                opacity: [0.3, 0.8, 0.3],
              }}
              transition={{
                duration: Math.random() * 3 + 2,
                repeat: Infinity,
                repeatType: "reverse",
              }}
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
              }}
            />
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="hero-content">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h1 className="hero-title">
            <span className="hero-title-light">Markanızı Yükselten</span>
            <br />
            <span className="hero-title-gradient">Profesyonel Medya Çözümleri</span>
          </h1>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="hero-description"
        >
          Sosyal medya yönetiminden prodüksiyon çekimlerine kadar her aşamada yanınızdayız.
          <br />
          Markanızın hikayesini en etkili şekilde anlatıyoruz.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <a href="#hizmetler" className="btn-primary">
            Hizmetlerimizi Keşfet
          </a>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        className="scroll-indicator"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="scroll-indicator-icon"
        >
          <motion.div
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="scroll-indicator-dot"
          />
        </motion.div>
      </motion.div>

      {/* Background Image Placeholder Comment */}
      {/* 
        Görsel prompt: "dark premium studio background with abstract lighting, cinematic mood, 8k, ultra realistic"
        Bu görsel hero bölümünün arka planında kullanılacak, koyu tema ile uyumlu, sinematik atmosfer yaratacak
      */}
    </section>
  );
};

export default Hero;